import { CommentDTO } from '../comment/comment.dto';
import { BaseDTO } from '../global/base.dto';
import { TeamListDTO } from '../team/team-list.dto';
import { UserListDTO } from '../user/user-list.dto';

export class MessageDTO extends BaseDTO {

    title: string;

    content: string;

    commentsEnabled: boolean;

    author: UserListDTO;

    comments: Array<CommentDTO>;

    teams: Array<TeamListDTO>;

}
